var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.536 10.8125C22.5378 9.55284 22.2903 8.30532 21.8079 7.14174C21.3255 5.97816 20.6176 4.92153 19.7251 4.03269C18.8325 3.14386 17.773 2.44039 16.6074 1.96281C15.4418 1.48522 14.1933 1.24296 12.9337 1.24996C7.6743 1.28981 3.46414 5.65934 3.46414 10.932V11.875C3.46414 16.6297 2.46805 19.3922 1.59149 20.9062C1.49839 21.0675 1.4493 21.2503 1.44914 21.4365C1.44897 21.6227 1.49774 21.8057 1.59055 21.9671C1.68336 22.1285 1.81695 22.2627 1.97795 22.3562C2.13895 22.4497 2.3217 22.4993 2.50789 22.5H23.4923C23.6785 22.4993 23.8612 22.4497 24.0222 22.3562C24.1832 22.2627 24.3168 22.1285 24.4096 21.9671C24.5024 21.8057 24.5512 21.6227 24.551 21.4365C24.5509 21.2503 24.5018 21.0675 24.4087 20.9062C23.5321 19.3922 22.536 16.6297 22.536 11.875V10.8125Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2499 22.5V23.5625C17.2499 24.6897 16.8022 25.7707 16.0051 26.5677C15.2081 27.3647 14.1271 27.8125 12.9999 27.8125C11.8728 27.8125 10.7918 27.3647 9.99474 26.5677C9.19771 25.7707 8.74994 24.6897 8.74994 23.5625V22.5",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ef893feee383a69a5f2b1a10a9729364.svg";
export { ForwardRef as ReactComponent };